
import type { IStateful } from '../app/types';
import { DEFAULT_LANGUAGE, i18next } from '../base/i18n';
import { getLocalParticipant, getParticipantById } from '../base/participants';
import { toState } from '../base/redux';
import { getBackendSafeRoomName } from '../base/util';
import { checkIfReactNative } from '../base/util/checkOS';

/**
 * Retrieves the current genericIFrame URL and replaces the placeholder with data.
 *
 * @param {Function|Object} stateful - The redux store or {@code getState} function.
 * @returns {?string} - Current genericIFrame URL or undefined.
 */
export function getGenericIFrameUrl(stateful: Function | IStateful) {
    const state = toState(stateful);
    const localParticipant = getLocalParticipant(state);
    let { iframeUrl } = state['features/genericiframe'];
    const { room } = state['features/base/conference'];
    const roomName = getBackendSafeRoomName(room);

    const { iAmRecorder } = state['features/base/config'];
    const participantName = iAmRecorder ? 'Recorder' : localParticipant?.name;
    const lang = i18next.language || DEFAULT_LANGUAGE;

    // white participants id
    const { partId } = state['features/genericiframe'];
    const participant = getParticipantById(state, partId);

    if (checkIfReactNative()) {
        iframeUrl = 'https://wbo.meethour.io/?username={username}&follow={follow}#room=meethour-{room},p6jFUzzS3QiMXr2ELVvXfQ';
    } else if (!iframeUrl) {
        return undefined;
    }

    iframeUrl = iframeUrl.replace('{username}', participantName ?? 'Guest');
    iframeUrl = iframeUrl.replace('{follow}', participant?.name || '');
    iframeUrl = iframeUrl.replace('{room}', roomName);
    iframeUrl = iframeUrl.replace('{lang}', lang);

    return `${iframeUrl}`;
}
